import * as React from 'react'
import { none, Option, some } from 'widgets-for-react'
import { matchPath } from 'react-router'
import { vacancyDetailPathPattern } from '../custom_pages/pages/vacancyDetailPage/vacancy_detail'

export const parseParagraphs = (input: string): string =>
  `<p>${input ? input.replace(/\n{2}/g, '</p><p>').replace(/[\n]/g, '<br />') : ''}</p>`

export const compareString: (a: string, b: string) => number = (a: string, b: string) => {
  return a < b ? -1 : a > b ? 1 : 0
}

export const sluggify: (str: string) => string = (str: string) => 
  str ? str.trim().toLowerCase().replace(/\'/gi, '').replace(/\s/gi, '-').replace(/\-\-/gi, '-') : ''

export const makeTextBold = (s: string, b: boolean) => 
  s ? (!b ? <> {s} </> : <b className="weight--bold"> {s} </b>) : ""

export const splitInBolds = (s: string) => 
  s ? s.split('*').map((s, index) => makeTextBold(s, Boolean(index % 2))) : ''

export const titleSplit = (title: string) => 
  title ? title.split('|').map((x, i) => <span key={i}>{splitInBolds(x)}</span>) : ''

export const removeBoldsAndSplits = (title: string) => 
  title ? title.split('|').join('').split('*').join('') : ''

export const removeBoldsAndSplitsButLastSplit = (title: string) => {
  if (!title) return ''
  const splits = title.split('|')
  const size = splits.length
  const pagetitle = splits
    .slice(0, size - 1)
    .join('')
    .replace(/\*/g, '')
    .replace(/\s+/g, ' ')
  const sitetitle = splits[size - 1]
  return pagetitle ? [pagetitle, sitetitle].join('|') : sitetitle
}

// Helper for <select> elements
export const toggleLabelFocus = (elementId: string) => {
  const el = document.querySelector(`#${elementId}`)
  el.parentElement.classList.contains('form__select--focus')
    ? el.parentElement.classList.remove('form__select--focus')
    : el.parentElement.classList.add('form__select--focus')
}

export const dashedToCamelCase = (s: string) => 
  s.split("-").map(capitalize).join("")

export const capitalize = (s) => s ? s[0].toUpperCase() + s.slice(1) : ''

export function withReference<T1,T2>(obj:T1,callback:(_:T1) => T2):T2 {
  return callback(obj)
}

export function withValue<T1,T2>(obj:T1,callback:(_:T1) => T2):T2 {
  return callback({...obj} as T1)
}

export function getVacancyIdFromUrl(): Option<string> {
  const match = matchPath(window.location.pathname, {
    path: vacancyDetailPathPattern,
    exact: true,
    strict: false
  })
  if (!match || !match.params || !match.params.vacancyId){
    return none()
  }
  return some(match.params.vacancyId)
}